module.exports = __webpack_public_path__ + "src/content/vid/bezierTwirlsFinalFaster.mp4";